import moment from "moment";

//Objeto de campo padronizado para envio a função validarCampos
export const objCampo = ({
  name,
  required,
  number,
  email,
  cnpj,
  cpf,
  cpfcnpj,
  date,
  birthDate,
  placa,
}) => {
  return {
    name,
    required,
    number,
    email,
    cnpj,
    cpf,
    cpfcnpj,
    date,
    birthDate,
    placa,
  };
};
export const validarCampos = (obj, campos) => {
  const objetoDeErros = {};

  //Regex para validação de email
  const emailRegex = /\S+@\S+/;

  //Regex para validação de placa de carro
  const placaRegex = /^[A-Za-z]{3}[0-9][0-9A-Za-z][0-9]{2}$/;

  const erros = campos.filter((campo) => {
    //Validação de campo obrigatorio
    if (
      !obj[campo.name] ||
      (campo.required &&
        (obj[campo.name] === "" ||
          obj[campo.name].length === 0 ||
          Object.keys(obj[campo.name]).length === 0))
    ) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "";
      return campo;
    }

    //Validação de campo numerico
    if (campo.number && isNaN(obj[campo.name].replace(",", "."))) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "* O valor não é numérico";
      return campo;
    } else if (
      campo.number &&
      parseFloat(obj[campo.name].replace(",", ".")) === 0.0
    ) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "";
      return campo;
    }

    //Validação de campo de email
    if (campo.email && !emailRegex.test(obj[campo.name])) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "* E-mail inválido";
      return campo;
    }

    //Validação de campo de placa de carro
    if (campo.placa) {
      const num = obj[campo.name].replace(/[^0-9a-zA-Z]/g, "");
      if (!placaRegex.test(num)) {
        objetoDeErros[campo.name] = {};
        objetoDeErros[campo.name].message = "* Placa inválida";
        return campo;
      }
    }

    //Validação de campo de cnpj
    if (campo.cnpj && !isValidCNPJ(obj[campo.name])) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "* CNPJ inválido";
      return campo;
    }

    //Validação de campo de cpf
    if (campo.cpf && !isValidCPF(obj[campo.name])) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "* CPF inválido";
      return campo;
    }

    //Validação de campo que possui a opção de ser cpf ou cnpj
    if (campo.cpfcnpj) {
      if (obj[campo.name].length <= 11 && !isValidCPF(obj[campo.name])) {
        objetoDeErros[campo.name] = {};
        objetoDeErros[campo.name].message = "* CPF inválido";
        return campo;
      } else if (
        obj[campo.name].length > 11 &&
        obj[campo.name].length <= 14 &&
        !isValidCNPJ(obj[campo.name])
      ) {
        objetoDeErros[campo.name] = {};
        objetoDeErros[campo.name].message = "* CNPJ inválido";
        return campo;
      }
    }

    //Validação de campo de data
    if (campo.date && !isValidDate(obj[campo.name])) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "* Data inválida";
      return campo;
    }

    //Validação de campo de aniversario
    if (campo.birthDate && !isValidDataNascimento(obj[campo.name])) {
      objetoDeErros[campo.name] = {};
      objetoDeErros[campo.name].message = "* Data inválida";
      return campo;
    }
  });

  return [objetoDeErros, erros];
};

// Função para mostrar o resultado do erro para determinado campo
export const PrintValidate = ({ errors, field }) => {
  return (
    <span className="mb-4">
      {errors[field] && (
        <span className={"form-control-label text-danger"}>
          {errors[field].message}
        </span>
      )}
    </span>
  );
};

//Função de validação de cnpj
export function isValidCNPJ(value) {
  if (!value) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    value === "00000000000000" ||
    value === "11111111111111" ||
    value === "22222222222222" ||
    value === "33333333333333" ||
    value === "44444444444444" ||
    value === "55555555555555" ||
    value === "66666666666666" ||
    value === "77777777777777" ||
    value === "88888888888888" ||
    value === "99999999999999"
  )
    return false;

  // Aceita receber o valor como string, número ou array com todos os dígitos
  const validTypes =
    typeof value === "string" ||
    Number.isInteger(value) ||
    Array.isArray(value);

  if (!validTypes) return false;

  let cnpj = value.toString().replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  if (cnpj.length !== 14) return false;

  // Elimina inválidos com todos os caracteres iguais
  if (/^(.)\\1+$/.test(cnpj)) return false;

  // Cálculo validador
  const getCharValue = (char) => {
    return char.charCodeAt(0) - 48;
  };

  const calc = (x) => {
    let sum = 0;
    let factor = x - 7;

    for (let i = x; i >= 1; i--) {
      const char = cnpj.charAt(x - i);
      const val = getCharValue(char);
      sum += val * factor--;
      if (factor < 2) factor = 9;
    }

    const result = 11 - (sum % 11);
    return result > 9 ? 0 : result;
  };

  // Valida 1o. dígito verificador
  const digit0 = calc(12);
  if (digit0 !== parseInt(cnpj.charAt(12))) return false;

  // Valida 2o. dígito verificador
  const digit1 = calc(13);
  return digit1 === parseInt(cnpj.charAt(13));
}

export function isValidCPF(cpf) {
  if (typeof cpf !== "string") return false;
  cpf = cpf.replace(/[\s.-]*/gim, "");
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === "00000000000" ||
    cpf === "11111111111" ||
    cpf === "22222222222" ||
    cpf === "33333333333" ||
    cpf === "44444444444" ||
    cpf === "55555555555" ||
    cpf === "66666666666" ||
    cpf === "77777777777" ||
    cpf === "88888888888" ||
    cpf === "99999999999"
  ) {
    return false;
  }
  var soma = 0;
  var resto;
  for (var i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
}

//Função de validação de data
function isValidDate(input_date) {
  if (!moment(input_date, "YYYY-MM-DD", true).isValid()) return false;
  else {
    var minDate = moment.utc("1900-01-01");
    if (moment(input_date, "YYYY-MM-DD", true).isAfter(minDate)) return true;
    else return false;
  }
}

export function IsValidDate(data) {
  const itemDate = moment(data);
  const currentDate = moment();
  return itemDate.isSame(currentDate, "day");
}

//Função de validação de data de nascimento
function isValidDataNascimento(input_date) {
  if (!isValidDate(input_date)) return false;
  else {
    var current_date = moment(new Date()).format("YYYY-MM-DD");
    var date = moment(input_date, "YYYY-MM-DD", true);

    if (date.diff(current_date, "days") > 0) return false;
    else return true;
  }
}
